import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

// The trail across the top of every signed-in page: Home / Overview / ...
//
// Each page names where it sits once, here, rather than every page drawing its
// own. Every step but the last is a link back. Pages not listed fall back to
// "Home / <the page's own name>", so a new page still gets a trail.

const MH = "Medical History & Questionnaire";

// path -> the steps AFTER "Home / Overview". A step is [label, path?].
const TRAILS = {
  Overview: [],
  MedicalHistory: [[MH]],
  MedicalSocialHistory: [[MH]],
  MedicalSocialHistory2: [[MH]],
  Medical_History: [[MH]],
  PreviousHistory: [[MH, "/MedicalHistory"], ["Previous history"]],
  PreviousFertilityTreatment: [[MH, "/MedicalHistory"], ["Previous history", "/PreviousHistory"], ["Fertility treatment"]],
  PreviousPregnancy: [[MH, "/MedicalHistory"], ["Previous history", "/PreviousHistory"], ["Pregnancy"]],
  Allergies: [[MH, "/MedicalHistory"], ["Allergies"]],
  PreviousProcedure: [[MH, "/MedicalHistory"], ["Previous history", "/PreviousHistory"], ["Procedures"]],
  Prescription: [[MH, "/MedicalHistory"], ["Prescriptions"]],
  PrescriptionDetail: [[MH, "/MedicalHistory"], ["Prescriptions", "/Prescription"], ["Prescription"]],
  DrugReminder: [[MH, "/MedicalHistory"], ["Drug reminder"]],
  Treatments: [["Treatments (with us)"]],
  TreatMentWithUs: [["Treatments (with us)", "/Treatments"]],
  TreatmentWithUs: [["Treatments (with us)"]],
  Cycle: [["Treatments (with us)", "/Treatments"], ["@cycle"]],
  TreatmentOutcome: [["Treatments (with us)", "/Treatments"], ["@cycle", "/Cycle"], ["Details and outcome"]],
  DicomViewer: [["Treatments (with us)", "/Treatments"], ["@cycle", "/Cycle"], ["Images"]],
  Appointment: [["Appointments"]],
  Conditions: [[MH, "/MedicalHistory"], ["Previous history", "/PreviousHistory"], ["Conditions"]],
  CaseCustomer: [["Cases"]],
  ChatCase: [["Cases", "/CaseCustomer"], ["Case"]],
  Invoices: [["Invoices"]],
  Checklist: [["Checklist"]],
  CheckList: [["Checklist"]],
  CheckListDetails: [["Checklist", "/CheckList"], ["Checklist details"]],
  ObservationResult: [["Observation results"]],
  HL7ObservationDetail: [["Observation results", "/ObservationResult"], ["Result report"]],
  Documents: [["Documents"]],
  ProfilePreview: [["Profile preview"]],
  PatientInfo: [["My profile"]],
  ProfileData: [["My details"]],
  PartnerDetails: [["Partner details"]],
  KbArticle: [["Knowledge base"]],
  Kb_Article: [["Knowledge base"]],
  Help: [["Help"]],
};

const cycleTitle = () => {
  try { return sessionStorage.getItem("TreatmentTitle") || sessionStorage.getItem("TreatmentName") || "Treatment"; } catch { return "Treatment"; }
};

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const page = pathname.split("/")[1] || "";

  if (!page || ["Home", "LoginMFA", "PinCode", "cookies", "cookiesdetails"].includes(page)) return null;

  const rest = page.startsWith("KbArticleDetails")
    ? [["Knowledge base", "/KbArticle"], ["Article"]]
    : TRAILS[page] || [[page.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ")]];

  const steps = [
    ["Home", "/Overview"],
    ...(page === "Overview" ? [["Overview"]] : [["Overview", "/Overview"], ...rest.map(([l, p]) => [l === "@cycle" ? cycleTitle() : l, p])]),
  ];

  return (
    <nav className="ox-crumbs" aria-label="Breadcrumb">
      {steps.map(([label, to], i) => {
        const last = i === steps.length - 1;
        return (
          <React.Fragment key={`${label}-${i}`}>
            {i > 0 && <span aria-hidden="true">/</span>}
            {last || !to ? (
              <strong aria-current={last ? "page" : undefined}>{label}</strong>
            ) : (
              <button type="button" className="ox-link" onClick={() => navigate(to)}>{label}</button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
